import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import addCarPlateInformationServices from '@src/services/addNewCar/addCarPlateInformation.services';

export const getVehicleDevicePlateValidation = createAsyncThunk(
  'getVehicleDevicePlateValidation',
  async ({ plate }, { getState, rejectWithValue }) => {
    try {
      const deviceTypeId = await getState()?.addCarType?.selectVehicleDeviceType;
      const vouId = await getState()?.addCarType?.selectVehicleProviderType;
      const data = await addCarPlateInformationServices.getVehicleDevicePlateValidation({
        deviceTypeId,
        vouId,
        plate,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  vehicleDevicePlateValidation: [],
  allPlatesArray: [],
  allPlatesDetails: [],
};

export const addCarPlateInformationSlice = createSlice({
  name: 'addCarPlateInformation',
  initialState,
  reducers: {
    resetCurrentLoadAddCarPlateInformation: (state) => {
      return initialState;
    },
    setAllPlatesArray: (state, action) => {
      state.allPlatesArray = action?.payload || [];
    },
    setAllPlatesDetails: (state, action) => {
      state.allPlatesDetails = action?.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleDevicePlateValidation.fulfilled, (state, action) => {
        state.vehicleDevicePlateValidation = action?.payload || [];
      })
      .addCase(getVehicleDevicePlateValidation.rejected, (state) => {
        state.vehicleDevicePlateValidation = [];
      });
  },
});

export const { resetCurrentLoadAddCarPlateInformation, setAllPlatesArray, setAllPlatesDetails } =
  addCarPlateInformationSlice.actions;
